(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["stats-block"] && !Shopify.designMode) return;
  try {
    
const NUM_SCROLL_DURATION_SECONDS = 4;
const STATS_BLOCK_SELECTOR = '.js-stats-block';
const NUM_SCROLL_SELECTOR = '.js-num-scroll';
const numScrollAnimations = new WeakMap();
let sharedNumScrollObserver;

function formatCounterValue(value, decimalPlaces) {
  const numberString = value.toFixed(decimalPlaces);
  const parts = numberString.split('.');
  let whole = parts[0];
  const fractional = parts.length > 1 ? `.${parts[1]}` : '';
  const rgx = /(\d+)(\d{3})/;

  while (rgx.test(whole)) {
    whole = whole.replace(rgx, '$1,$2');
  }

  return whole + fractional;
}

function createCountUp(target, startVal, endVal, decimals, durationSeconds) {
  const domNode = typeof target === 'string' ? document.getElementById(target) : target;

  if (!domNode) {
    return { start() {} };
  }

  const startNumber = Number(startVal);
  const endNumber = Number(endVal);

  if (!Number.isFinite(startNumber) || !Number.isFinite(endNumber)) {
    return { start() {} };
  }

  const decimalPlaces = Math.max(0, decimals || 0);
  const decimalMult = Math.pow(10, decimalPlaces);
  const durationMs = Math.max(0, Number(durationSeconds) * 1000 || 2000);
  let rafId;
  let animationStart;

  function render(value) {
    domNode.textContent = formatCounterValue(value, decimalPlaces);
  }

  function easeOutExpo(progress) {
    if (progress === 1) return 1;
    return 1 - Math.pow(2, -10 * progress);
  }

  function tick(timestamp) {
    if (animationStart === undefined) animationStart = timestamp;

    const elapsed = Math.min(timestamp - animationStart, durationMs);
    const progress = durationMs === 0 ? 1 : elapsed / durationMs;
    const easedProgress = easeOutExpo(progress);
    let frameValue = startNumber + (endNumber - startNumber) * easedProgress;

    frameValue = Math.round(frameValue * decimalMult) / decimalMult;
    render(frameValue);

    if (elapsed < durationMs) {
      rafId = window.requestAnimationFrame(tick);
      return;
    }

    render(endNumber);
  }

  render(startNumber);

  return {
    start() {
      animationStart = undefined;
      window.cancelAnimationFrame(rafId);

      if (durationMs === 0) {
        render(endNumber);
        return;
      }

      rafId = window.requestAnimationFrame(tick);
    }
  };
}

function initNumScroll(numScrollElem) {
  if (numScrollElem.dataset.numScrollInit === 'true') return;

  const startVal = Number(numScrollElem.dataset.numScrollStart);
  const endVal = Number((numScrollElem.textContent || '').replace(/,/g, '').trim());
  if (!Number.isFinite(startVal) || !Number.isFinite(endVal)) return;

  numScrollElem.dataset.numScrollInit = 'true';

  const decimalPlaces = Number.isInteger(endVal) ? 0 : 2;

  const anim = createCountUp(numScrollElem, startVal, endVal, decimalPlaces, NUM_SCROLL_DURATION_SECONDS);
  numScrollAnimations.set(numScrollElem, anim);

  if (!('IntersectionObserver' in window)) {
    anim.start();
    return;
  }

  if (!sharedNumScrollObserver) {
    sharedNumScrollObserver = new IntersectionObserver((entries, observer) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;

        const entryAnim = numScrollAnimations.get(entry.target);
        if (entryAnim) entryAnim.start();
        observer.unobserve(entry.target);
      });
    });
  }

  sharedNumScrollObserver.observe(numScrollElem);
}

function initStatsBlockSection(sectionElem) {
  if (!sectionElem || sectionElem.dataset.statsBlockInit === 'true') return;

  sectionElem.dataset.statsBlockInit = 'true';
  sectionElem.querySelectorAll(NUM_SCROLL_SELECTOR).forEach(initNumScroll);
}

function initAllStatsBlockSections(root) {
  const scope = root || document;

  if (scope.matches && scope.matches(STATS_BLOCK_SELECTOR)) {
    initStatsBlockSection(scope);
  }

  scope.querySelectorAll(STATS_BLOCK_SELECTOR).forEach(initStatsBlockSection);
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => initAllStatsBlockSections());
} else {
  initAllStatsBlockSections();
}

document.addEventListener('shopify:section:load', (event) => {
  initAllStatsBlockSections(event.target || document);
});

document.addEventListener('shopify:section:unload', (event) => {
  const scope = event.target;
  if (!scope) return;

  scope.querySelectorAll(NUM_SCROLL_SELECTOR).forEach((elem) => {
    if (sharedNumScrollObserver) {
      sharedNumScrollObserver.unobserve(elem);
    }
    numScrollAnimations.delete(elem);
    delete elem.dataset.numScrollInit;
  });

  if (scope.matches && scope.matches(STATS_BLOCK_SELECTOR)) {
    delete scope.dataset.statsBlockInit;
  }

  scope.querySelectorAll(STATS_BLOCK_SELECTOR).forEach((sectionElem) => {
    delete sectionElem.dataset.statsBlockInit;
  });
});

  } catch(e) { console.error(e); }
})();
})();
